// The live page's third sheet (LU1, Trevor 2026-10-20): POR's guard combinations in the game so far, the report's
// Guard Lineups section with the game group alone and no expected columns (the live feed has no shot predictions).
// Written at each completed period by kpi.run --live (reports.kpi_guard_lineups_live).
import GuardLineupsSection from "../../../TeamReport/GuardLineups/GuardLineupsSection";
import { Masthead } from "./common";
import { gameMeta, liveMeta } from "./kpiLib";
import type { KpiResponse } from "./types";

export default function GuardLineupsLivePage({ data }: { data: KpiResponse }) {
  if (!data.guardLineups || !data.meta.game) return null;
  const g = liveMeta(gameMeta(data.meta.game, data.meta.porGamesToDate), data.meta.live?.throughPeriod);
  return (
    <section className="page tall" data-screen-label="Guard Lineups">
      <Masthead g={g} who="Guard Lineups · Live" kicker="Portland Trail Blazers · Lineups" title="Guard Lineups"
                report="Live KPIs" />
      <GuardLineupsSection data={data.guardLineups} showTitle={false} />
    </section>
  );
}
